export default "__VITE_ASSET___4iUDMj5__"